export default "__VITE_ASSET__974fdfe3__"